module.exports = __webpack_public_path__ + "static/media/logo-internal.5e163d21.png";